export default "__VITE_ASSET__DMHKxyYP__"